import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);



export const getArticleDay= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getArticleDayBerlin/select/`);
export const addArticleDay = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addArticleDayBerlin/send`, job);
export const updateArticleDay = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateArticleDayBerlin/${user.ID}`, user);
export const deleteArticleDay= user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteArticleDayBerlin/${user}`);


export const getNews_Category= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getNews_CategoryBerlin/select/`);
export const addNews_Category = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addNews_CategoryBerlin/send`, job);
export const updateNews_Category = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateNews_CategoryBerlin/${user.ID}`, user);
export const deleteNews_Category= user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteNews_CategoryBerlin/${user}`);

export const getSongCategory= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getSong_CategoryBerlin/select/`);
export const addSongCategory = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addSong_CategoryBerlin/send`, job);
export const updateSongCategory = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateSong_CategoryBerlin/${user.ID}`, user);
export const deleteSongCategory= user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteSong_CategoryBerlin/${user}`);



export const addNews = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addNewsBerlin/send`, job);
export const updateNews = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateNewsBerlin/${user.ID}`, user);
export const deleteNews = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteNewsBerlin/${user}`);

export const getNe= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getBlogRehber/select/`);
export const addNe = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addBlogRehber/send`, job);
export const updateNe = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateBlogRehber/${user.ID}`, user);
export const deleteNe = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteBlogRehber/${user}`);



export const getNews_Comment= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getNews_CommentBerlin/select/`);
export const deleteNews_Comment = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteNews_CommentBerlin/${user}`);
export const addForum = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addDoctorCategory/send`, job);




export const getPool= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getPoolBerlin/select/`);
export const addPool = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addPoolBerlin/send`, job);
export const updatePool = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updatePoolBerlin/${user.ID}`, user);
export const deletePool = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deletePoolBerlin/${user}`);

export const getNews= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getBlogRehber/select/`);
export const updateAbout = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateAboutRehber/${user.ID}`, user);
export const getAbout = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getAboutRehber/select/`);
export const getAbout2 = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getReferancesRehber/select/`);
export const updateAbout2 = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateReferancesRehber/${user.ID}`, user);

export const getFeedBack = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getFeedBack/select/`);
export const updateFeedBack = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateFeedBack/${user.ID}`, user);
export const addFeedBack= job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addFeedBack/send`, job);
export const deleteFeedBack= project =>
del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteFeedBack/${project}`);

export const getDynamicForm2 = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDiagnosticForm/select/`);
export const updateDynamicForm2 = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateDiagnosticForm/${user.ID}`, user);
export const addDynamicForm2= job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addDiagnosticForm/send`, job);
export const deleteDynamicForm2= project =>
del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDiagnosticForm/${project}`);



export const getUsers = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUsersRehber/select/`);
export const addUser = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addUsersRehber/send`, job);
export const updateUser = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateUsersRehber/${user.ID}`, user);
export const deleteUser = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteUsersRehber/${user}`);
export const deleteUser2 = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteUsersRehber/${user}`);


export const getSong= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getPodcast/select/`);
export const addSong = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addPodcast/send`, job);
export const updateSong = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updatPodcast/${user.ID}`, user);
export const deleteSong = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deletePodcast/${user}`);

export const getSliders = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUsersAppointment/select/`);
export const updateSlider = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateUserAppointment/${user.ID}`, user);
export const deleteSlider = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/Users_Appointment/${project}`);
  export const addSlider = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addUsersAppointment/send`, job);




  export const getAdvertesing_Category = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getAdvertesing_CategoryBerlin/select/`);
  export const updateAdvertesing_Category = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateAdvertesing_CategoryBerlin/${user.ID}`, user);
  export const deleteAdvertesing_Category = project =>
    del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteAdvertesing_CategoryBerlin/${project}`);
    export const addAdvertesing_Category = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addAdvertesing_CategoryBerlin/send`, job);
  
  


  export const getAdvertesing_Form = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getComplatedOrder/select/`);
  export const updateAdvertesing_Form = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateComplatedOrder/${user.ID}`, user);
  export const deleteAdvertesing_Form = project =>
    del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteComplatedOrder/${project}`);
    export const addAdvertesing_Form = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addComplatedOrder/send`, job);
  
  

    export const getJob_Advertisement_Category = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUserWallet/select/`);
    export const updateJob_Advertisement_Category = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateUserWallet/${user.ID}`, user);
    export const deleteJob_Advertisement_Category = project =>
      del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteUserWallet/${project}`);
      export const addJob_Advertisement_Category = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addUserWallet/send`, job);
    
    



      export const getJob_Advertisement_SubCategory = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDoctorList/select/`);
      export const updateJob_Advertisement_SubCategory = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateDoctorList/${user.ID}`, user);
      export const deleteJob_Advertisement_SubCategory = project =>
        del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDoctorList/${project}`);
        export const addJob_Advertisement_SubCategory = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addDoctorList/send`, job);
      
      

  
      export const getJob_Advertisement = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getJob_AdvertisementBerlin/select/`);
      export const deleteJob_Advertisement = project =>
        del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteJob_AdvertisementBerlin/${project}`);
     
  

        export const getForum = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDoctorCategory/select/`);
        export const updateForum = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateDoctorCategory/${user.ID}`, user);
        export const deleteForum = project =>
          del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDoctorCategory/${project}`);
    
  export const getSubEducation = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getSlidersBerlin/select/`);
  export const updateSubEducation = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateSlidersBerlin/${user.ID}`, user);
  export const deleteSubEducation = project =>
    del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteSlidersBerlin/${project}`);
    export const addSubEducation= job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addSlidersBerlin/send`, job);
  

  export const getCompany_Category = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getCompany_CategoryBerlin/select/`);
export const updateCompany_Category = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateCompany_CategoryBerlin/${user.ID}`, user);
export const deleteCompany_Category = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteCompany_CategoryBerlin/${project}`);
  export const addCompany_Category = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addCompany_CategoryBerlin/send`, job);


export const getCompany_SubCategory = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getQuestions/select/`);
export const updateCompany_SubCategory = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateQuestions/${user.ID}`, user);
export const deleteCompany_SubCategory = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteQuestions/${project}`);
  export const addCompany_SubCategory = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addQuestions/send`, job);



  export const getMainPage_Category= () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getQuestionsAnswerRange/select/`);
export const updateMainPage_Category = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateQuestionsAnswerRange/${user.ID}`, user);
export const deleteMainPage_Category= project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteQuestionsAnswerRange/${project}`);
  export const addMainPage_Category = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addQuestionsAnswerRange/send`, job);





  export const getCompany_Advert_Price = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDoctorsReview/select/`);
  export const updateCompany_Advert_Price= user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateDoctorsReview/${user.ID}`, user);
  export const deleteCompany_Advert_Price = project =>
    del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDoctorsReview/${project}`);
    export const addCompany_Advert_Price = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addDoctorsReview/send`, job);
  

export const getCompany = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getCompanyBerlin/select/`);
export const addCompany  = user => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addCompanyBerlin/send`, user);
export const updateCompany  = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateCompanyBerlin/${user.ID}`, user);
export const deleteCompany  = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteCompanyBerlin/${user}`);


export const addEducation = user => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addEducationNefes/send`, user);
export const addProductCategory = user => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addProductsCategoryLuxun/send`, user);
export const deleteProductCategory = user => del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteProductCategoryLuxun/${user}`);
export const updateProductCategory = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateProductCategoryLuxun/${user.ID}`, user);

export const updateEducation = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateEducationNefes/${user.ID}`, user);

export const updateContact = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateContactCastor/${user.ID}`, user);
export const getCategory = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getProductsCategoryLuxun/select/`);
export const getProducts1 = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getProductsLuxun/select/`);

export const getSSS = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getSSSPort/select/`);
export const getBlogs = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getBlogCastor/select/`);

export const addNewUser = user => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postForumBerlin/send`, user);

export const getProjectsNew = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEducationNefes/select/`);
export const getEducation = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEducationNefes/select/`);
export const getEducationSubItem = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEducationSubItemNefes/select/`);
export const getWorkShop = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getTeacherMega/select/`);

export const getEventMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEventMega/select/`);

export const getDynamicFormMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getPoolQuestion/select/`);
export const updateDynamicForm = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updatePoolQuestion/${user.ID}`, user);
export const addDynamicForm = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addPoolQuestion/send`, job);
export const deleteDynamicForm = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deletePoolQuestion/${project}`);
const postFakeLogin = data => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUserLoginRehber/select/${data.email}/${data.password}`,);


export const getMegaMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getMegaMega/select/`);

export const getMailsLists = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getContactMessageMega/select/`);

// add user

export const getEvents = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEventMega/select/`);
export const getCategories = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getEventCategoryMega/select/`);


export const updateSubDomain = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchUserMega/${user.ID}`, user);


export const updateSSS = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateSSSPort/${user.ID}`, user);

export const updateProduct = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateProductLuxun/${user.ID}`, user);
export const updateBlog = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/updateBlogCastor/${user.ID}`, user);



export const updateProject = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchUpdateProject/${user.ID}`, user);




export const addSSS= job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addSSSPort/send`, job);
export const addProduct = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addProductLuxun/send`, job);

export const addBlog = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addBlogCastor/send`, job);
export const addProject = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addProject/send`, job);



export const addMega = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addMega/send`, job);

export const addCourseMega = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addCourseMega/send`, job);

export const updateSubdomain = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchSUBDOMAINMega/${user.ID}`, user);



export const updateAuth = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchAuthMega/${user.ID}`, user);

export const updateMega = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postWSMega/send`, job);

export const addWorkshop2 = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getContactCastor/select/`);
export const getAuthority = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getUsersTypeMega/select/`);
export const getWorkshop2 = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getGalleryMega/select/`);

export const addNewEvent = event => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postEventMega/send/`, event);

export const getChats = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postSubdomainMega/send/`, event);
export const getReferances = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

export const addReferances = event => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postReferancesMega/send/`, event);

export const updateReferances = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getClassesMega/select/`);

export const getDynamicFormExtraMega = (ID = "") => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDynamicFormExtraMega/select/${ID}`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDynamicExtraExtraFormMega/${project}`);


export const deleteDynamicFormExtra = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteReferancesMega/${project}`);

export const deletePopup = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteQuestionSubCategory/${project}`);
export const getPopup = () => get(`https://drrandevuadmin.stechomeyazilim.info:4435/getQuestionSubCategory/select/`);
export const updatePopup = user => patch(`https://drrandevuadmin.stechomeyazilim.info:4435/patchQuestionSubCategory/${user.ID}`, user);
export const addPopup = job => post(`https://drrandevuadmin.stechomeyazilim.info:4435/addQuestionSubCategory/send`, job);



  export const deleteSSS = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteSSSPort/${project}`);
  





export const deleteProduct = project =>
del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteProductLuxun/${project}`);

  export const deleteBlog = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteblogCastor/${project}`);


  
export const deleteMega = project =>
  del(`https://drrandevuadmin.stechomeyazilim.info:4435/deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get maillist
//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};